// extracted by mini-css-extract-plugin
export var content = "_bp-3";
export var list = "_bp-4";
export var settingsContent = "_bp-7";
export var settingsPanel = "_bp-8";
export var state = "_bp-6";
export var triggerBadge = "_bp-2";
export var triggerButton = "_bp-1";
export var triggerShell = "_bp-0";
export var unreadDot = "_bp-5";